// return a header object with the JWT token from the Redux store
export function JWTHeader(jwt:string | null): RequestInit {
  if (!jwt) {
    return {};
  }
  return {
    headers: {
      Authorization: `Bearer ${jwt}`,
    },
  };
}

export function JWTAuthorization(jwt:string | null): string {
  if (!jwt) {
    return '';
  }
  return `Bearer ${jwt}`;
}
